/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ffmpeg_CommandInputs */



/**
* | output |
* | --- |
* | "FFmpeg command" |
*
* @param {Audio_Embed_Export_Ffmpeg_CommandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ffmpeg_command = /** @type {((inputs?: Audio_Embed_Export_Ffmpeg_CommandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ffmpeg_CommandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("commande FFmpeg")
	if (locale === "de") return /** @type {LocalizedString} */ ("FFmpeg-Befehl")
	if (locale === "it") return /** @type {LocalizedString} */ ("comando FFmpeg")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Команда FFmpeg")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comando FFmpeg")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("FFmpeg 命令")
	if (locale === "ja") return /** @type {LocalizedString} */ ("FFmpegコマンド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("FFmpeg कमांड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("comando FFmpeg")
	return /** @type {LocalizedString} */ ("FFmpeg command")
});